import * as Sentry from '@sentry/react';

function getApprovalPath(
    actionType: string,
): 'ops' | 'procurement' | 'unknown' {
    if (
        actionType === 'DivisionManagerApproval' ||
        actionType === 'OpsExecutiveEscalationApproval'
    ) {
        return 'ops';
    }
    if (
        actionType === 'ProcurementManagerApproval' ||
        actionType === 'ProcurementExecutiveEscalationApproval' ||
        actionType === 'SupplierEngagement'
    ) {
        return 'procurement';
    }
    return 'unknown';
}

export function trackPriceChangeTimeToAction(params: {
    timeToActionSeconds: number;
    outcome: string;
    actionType: string;
}): void {
    const { timeToActionSeconds, outcome, actionType } = params;
    const path = getApprovalPath(actionType);

    Sentry.metrics.distribution(
        'price_change_time_to_action',
        timeToActionSeconds,
        {
            unit: 'second',
            attributes: {
                outcome,
                action_type: actionType,
                path,
            },
        },
    );
}
